import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'vr-delete-modal',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public defaults: any,
    private dialogRef: MatDialogRef<DeleteDialogComponent>
  ) {}

  cancel() {
    this.dialogRef.close();
  }

  delete() {
    if (this.defaults.Enterprises) {
      this.dialogRef.close(this.defaults.Enterprises.id);
    } else if (this.defaults.Users) {
      this.dialogRef.close(this.defaults.Users.id);
    } else if (this.defaults.Frames) {
      this.dialogRef.close(this.defaults.Frames.id);
    } else if (this.defaults.frame_name) {
      this.dialogRef.close(this.defaults.id);
    } else if (this.defaults.Audits) {
      this.dialogRef.close(this.defaults.Audits.id);
    }
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/deleted-dialog/delete-dialog.component.ts